import { render, staticRenderFns } from "./ConsumptionPieWidget.vue?vue&type=template&id=10db0d10"
import script from "./ConsumptionPieWidget.vue?vue&type=script&lang=js"
export * from "./ConsumptionPieWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports